export default __webpack_public_path__ + "static/media/family-islands.e01003e0.jpg";